import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=4e2f3754&scoped=true"
import script from "./ProductSelect.vue?vue&type=script&lang=js"
export * from "./ProductSelect.vue?vue&type=script&lang=js"
import style0 from "./ProductSelect.vue?vue&type=style&index=0&id=4e2f3754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2f3754",
  null
  
)

export default component.exports